import React from "react";

const ToggleSwitch = ({ label, checked, onChange }) => {
  return (
    <div className="flex items-center justify-between">
      <label className="text-sm text-gray-700 mr-2">{label}</label>
      <label className="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="sr-only peer"
        />
        <div className="w-11 h-6 bg-gray-300 peer-checked:bg-primary rounded-full relative transition">
          <div className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition peer-checked:translate-x-full"></div>
        </div>
      </label>
    </div>
  );
};

export default ToggleSwitch;
